import { GoogleLoginProvider, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient } from '@angular/common/http';
import { ApplicationRef, NgModule, ViewContainerRef, isDevMode } from '@angular/core';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { TokenInterceptor } from '../shared/interceptors/token/token.interceptor';
import { LoaderService } from '../shared/services/loader/loader.service';
import { SharedModule } from '../shared/shared.module';
import { ROOT_REDUCERS } from '../shared/states/app.state';
import { AppRoutingModule } from './app-routing.module';
import { AppLayoutComponent } from './components/app-layout/app-layout.component';
import { AppComponent } from './components/app/app.component';
import { GraphQLModule } from './graphql.module';
import { ServiceWorkerModule } from '@angular/service-worker';

registerLocaleData(localeEs, 'es')
@NgModule({
  declarations: [
    AppComponent,
    AppLayoutComponent
  ],
  imports: [
    HttpClientModule,
    JwtModule.forRoot({
      config: {
        allowedDomains: ["sarkosgroup.com"],
        tokenGetter: () => JSON.parse(localStorage.getItem('sessionAuthState') || ''),
      },
    }),
    SharedModule,
    SharedModule.forRoot(),
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    StoreModule.forRoot(ROOT_REDUCERS),
    StoreDevtoolsModule.instrument(),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: true }),
    GraphQLModule,
  ],
  providers: [
    CookieService,
    provideHttpClient(),
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '847047958793-2bellvk4avv60j6dcdc12gcbetaka15q.apps.googleusercontent.com',
              {
                scopes: 'profile email',
                oneTapEnabled: false,
              }
            ),
          },
        ],
      } as SocialAuthServiceConfig,
    },
    {
      provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true,
    },
    {
      provide: 'environment', useValue: environment,
    },
    {
      // Se utiliza para permitir la generacion de modales por el servicio -> ModalActionService
      provide: 'APP_VIEW_CONTAINER_REF',
      useFactory: (appRef: ApplicationRef) => {
        return appRef.components[0].injector.get(ViewContainerRef);
      },
      deps: [ApplicationRef],

    },
    LoaderService,
    { provide: LOCALE_ID, useValue: 'es' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
